export const src = "./img/lady_1.png";

export const data = [
  {
    tag: "savings",
    title: "Create multiple saving plans",
    imgUrl: "./img/jar.png",
    alt: "A jar for svaing money",
    description: "Earn better interest rates than your bank.",
    buttonText: "start saving",
    bgColor: `var(--color-accent-001)`,
  },
  {
    tag: "circles",
    title: "Save with friends",
    imgUrl: "./img/award.png",
    alt: "an award photo showing hard earned results",
    description: "Stay motivated and have fun saving with friends and family.",
    buttonText: "join a circle",
    bgColor: `var(--color-accent-002)`,
  },
  {
    tag: "mutual funds",
    title: "Play the long-term game",
    imgUrl: "./img/pizza.png",
    alt: "Stacking up result for long term",
    description: "Invest in diverse and quality mutual funds with any amount.",
    buttonText: "start investing",
    bgColor: `var(--color-accent-003)`,
  },
  {
    tag: "emergency fund",
    title: "Save for the rainy day",
    imgUrl: "./img/umbrella.png",
    alt: "unmbrella to safe guard you and your earnings",
    description: "Build a safety net for unexpected expenses.",
    buttonText: "create your own emergency plan",
    bgColor: `var(--color-accent-004)`,
  },
  {
    tag: "stash",
    title: "Your secure digital wallet",
    imgUrl: "./img/cash.png",
    alt: "digital currency supports for all users",
    description:
      "Send and receive cash in seconds for free. You only need their username.",
    buttonText: "explore it now",
    bgColor: `var(--color-primary)`,
    color: `var(--color-white)`,
  },
  {
    tag: "US stocks and bonds (Coming soon)",
    title: "Grow your global portfolio",
    imgUrl: "./img/chart.png",
    alt: "chart of portfolio all over the globe",
    description: "",
    buttonText: "get early access",
    bgColor: `var(--color-accent-005)`,
  },
];

export const buildContent = [
  {
    id: "01",
    title: "Create an account",
    description:
      "Sign up for an account with your name, email and phone number",
  },
  {
    id: "02",
    title: "Add a payment method",
    description:
      "Using your debit card, bank account, USSD, QR Code, setupyour  first plan.",
  },
  {
    id: "03",
    title: "Watch your money grow",
    description:
      "Sit back, relax & let your money work for you all day, everyday",
  },
];

export const safes = [
  {
    title: "Bank-grade security",
    description:
      "We are PCI-DSS compliant to ensure secuurity of your data electronically. we also provide you with an option to set up 2FA for key transaction on your account. Serves as an extra layer of protection to ensure the security of your account beyond just a username and password.",
  },
  {
    title: "Assets Custody",
    description:
      "Our user’s financial assets are held with a licensed custodian, Zenith Nominees Limited, for safekeeeping to preent misapropriation, miuse, theft, and/or loss and in accordance with applicable law.",
  },
  {
    title: "Regulatory Compliance",
    description:
      "Cowrywise is duly registered fund manager with the securities and exchange Comission (SEC) of nigeria. All our activities are in full compliance with regulatorty requirement to the ultimate protection of our clients. ",
  },
  {
    title: "Regulatory Compliance",
    description:
      "All the investment option listed oon cowrywise, are carefully screened, managed by professional fund managers. All the diverse mutual funds registered with the SEC, with standard third-party custodian structure",
  },
];

export const reviews = [
  {
    rating: 4.4,
    title: "Available on the Play Store",
    comment:
      "‘‘User interfaceis fantastic, deposit and wihdrawals flawless and fast. I wish i had discovered this years ago, would have been a  illionaire by now’’ - Obiora, Nov 2021",
    store: "Play Store",
    alt: "download app from google play store",
    imgUrl: "./img/playstore_logo.png",
  },
  {
    rating: 4.5,
    title: "Available on the App Store",
    comment:
      "‘’I just don’t know what to say about this app all i know is that it’s awesome, it’s been 2 years plus and ihaven’t had a reason to complain’’ - Henrietta, december 2021",
    store: "App Store",
    alt: "download app from apple play store",
    imgUrl: "./img/apple_logo.png",
  },
];

export const footers = [
  {
    title: "company",
    links: ["about us", "press", "careers", "ambassadors", "privacy", "terms"],
  },
  {
    title: "product",
    links: [
      "Saving Plans",
      "Investment Plans",
      "Mutual Funds",
      "Stash",
      "Embed API",
      "Sprout",
      "Circles",
      "Halal",
      "Got a suggestion?",
    ],
  },
  {
    title: "resources",
    links: [
      "customer stories",
      "Media",
      "FAQs",
      "Security",
      "Estimate your interest",
      "Plan Education",
      "Blog",
      "Help Center",
    ],
  },
  {
    title: "contact",
    links: [" support@cowrywise.com", "whatsapp "],
  },
];
